module.exports = __webpack_public_path__ + "assets/img/pop-3.3a75d670.jpg";